import { ClickAwayListener, Grid } from '@mui/material';
import React from 'react';

type RenderFunctionProps = {
  overlay: boolean;
};

type ComponentOverlayProps = {
  disabledOverlay?: boolean;
  overlayClassName?: string;
  onClickAway?: (event: MouseEvent | TouchEvent) => void;
  id?: string;
};

type ComponentOverlayPropsWithChildren = {
  children: React.ReactNode;
  render?: never;
};
type ComponentOverlayPropsWithRenderProp = {
  render: (props: RenderFunctionProps) => React.ReactNode;
  children?: never;
};

type Props = (
  | ComponentOverlayPropsWithChildren
  | ComponentOverlayPropsWithRenderProp
) &
  ComponentOverlayProps;

function ComponentOverlay({
  disabledOverlay = false,
  overlayClassName,
  children,
  render,
  onClickAway,
  id,
}: Props) {
  const [overlay, setOverlay] = React.useState(true);

  const onDoubleClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabledOverlay) {
      return;
    }
    setOverlay(false);
  };

  const handleClickAway = (event: MouseEvent | TouchEvent) => {
    if (disabledOverlay) {
      return;
    }
    setOverlay(true);
    onClickAway && onClickAway(event);
  };

  const isOverlay = !disabledOverlay && overlay;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Grid
        id={id}
        onDoubleClick={onDoubleClick}
        container
        component='span'
        sx={{ cursor: isOverlay ? 'pointer' : 'default' }}
        position='relative'
      >
        <Grid
          position='absolute'
          left={0}
          right={0}
          top={0}
          bottom={0}
          zIndex={1000}
          container
          className={isOverlay ? overlayClassName : ''}
          sx={{
            display: isOverlay ? 'default' : 'none',
          }}
          component='span'
        />
        {render
          ? render({
              overlay,
            })
          : children}
      </Grid>
    </ClickAwayListener>
  );
}

export default ComponentOverlay;
